/* eslint-disable */
import { takeEvery, call, put } from 'redux-saga/effects';
import { GET_ORDER_DETAIL, SET_ORDER_DETAIL } from '../actions';
import { apiUrl } from "../components/Helpers/Config";
import Axios from 'axios';
import cookie from 'react-cookies';

export const watchGetOrderDetail = function* () {
  yield takeEvery(GET_ORDER_DETAIL, workerGetOrderDetail);
}

function* workerGetOrderDetail({ orderId }) {
  try {

  var app_id = cookie.load("merchant_app_id") !== "" && cookie.load("merchant_app_id") !== undefined && cookie.load("merchant_app_id") !== null
              ? cookie.load("merchant_app_id")
               : '';

  const uri = apiUrl + 'chopchop/reports/order_history?app_id=' + app_id + "&local_order_no=" + orderId + "&customer_id=" + cookie.load('CustomerUserId');
  const result = yield call(Axios.get, uri);
	var resultArr = [];
	resultArr.push(result.data);
    yield put({ type: SET_ORDER_DETAIL, value: resultArr });
  } 
  catch {
    console.log('Get Order Detail Failed');
  }
}

